import React from 'react';
import { func } from 'prop-types';
import { UIButton } from 'app/components/ui';

import './addMoreDishes.scss';
import { useRouterState } from 'app/hooks/useRouterState';
import { useReactiveVar } from '@apollo/client';
import { isGlobalLoadingVar } from 'app/apollo/reaction';

const AddMoreDishesButton = (props) => {
    const { handleAddMoreButtonClick } = props;
    const [{ location: { pathname } }] = useRouterState();

    const isGlobalLoading = useReactiveVar(isGlobalLoadingVar);

    if (pathname === '/basket/') {
        return <div styleName="fake-button-divider" />;
    }

    return (
        <div styleName="add-more-button-root">
            <div styleName="add-more-button-wrapper">
                <UIButton
                    centerContent="Добавить блюда"
                    onClick={() => handleAddMoreButtonClick('intresting')}
                    aria-label="Получить код"
                    sizeType="large"
                    colorType="secondary"
                    disabled={isGlobalLoading}
                />
            </div>
        </div>
    );
};

AddMoreDishesButton.propTypes = {
    handleAddMoreButtonClick: func.isRequired,
};

export default React.memo(AddMoreDishesButton);
